import {Injectable, OnDestroy} from '@angular/core';
import {WicketUserActivityService} from '@tisa-group/core/api/wicket';
import {ContentWatchActivity, WicketUserActivity} from '@tisa-group/models';
import {v4 as uuidv4} from 'uuid';

@Injectable()
export class ContentWatchLogService implements OnDestroy {
  private readonly _userActivityData: WicketUserActivity = {
    type: 'event.watch',
    properties: {
      eventId: '',
      eventFormatAvailability: null,
      sessionId: uuidv4(),
      watchTime: 0,
      eventTitle: '',
      eventType: '',
      applicationCode: '',
    },
  };

  private _postRequestIntervalId: any;

  private _lastPostTimeStamp = 0;

  readonly postIntervalTime = 30000;

  constructor(private readonly _wicketUserActivityService: WicketUserActivityService) {}

  ngOnDestroy(): void {
    this.stopWatchLog();
  }

  startWatchLog({
    eventTitle,
    eventType,
    eventId,
    eventFormatAvailability,
    applicationCode,
  }: Pick<
    ContentWatchActivity,
    'eventId' | 'eventFormatAvailability' | 'eventTitle' | 'eventType' | 'applicationCode'
  >): void {
    if (this._postRequestIntervalId) {
      return;
    }

    this._userActivityData.properties.eventTitle = eventTitle;
    this._userActivityData.properties.eventType = eventType;
    this._userActivityData.properties.watchTime = 1;
    this._userActivityData.properties.eventId = eventId;
    this._userActivityData.properties.eventFormatAvailability = eventFormatAvailability;
    this._userActivityData.properties.applicationCode = applicationCode;
    this._startIntervalForUserActivity();
    this._postUserActivity();
  }

  stopWatchLog(): void {
    if (!this._postRequestIntervalId) {
      return;
    }

    clearInterval(this._postRequestIntervalId);
    this._postRequestIntervalId = undefined;
    this._userActivityData.properties.watchTime =
      this._getTimeDifferenceBetweenNowAndLastPost();
    this._postUserActivity();
  }

  private _startIntervalForUserActivity(): void {
    this._postRequestIntervalId = setInterval(() => {
      this._userActivityData.properties.watchTime = this.postIntervalTime / 1000;
      this._postUserActivity();
    }, this.postIntervalTime);
  }

  private _postUserActivity(): void {
    this._wicketUserActivityService.postUserActivity(this._userActivityData).subscribe(
      () => this._updateLastPostTimeStamp(),
      () => this._updateLastPostTimeStamp(),
    );
  }

  private _updateLastPostTimeStamp(): void {
    this._lastPostTimeStamp = new Date().getTime();
  }

  private _getTimeDifferenceBetweenNowAndLastPost(): number {
    const now = new Date().getTime();

    if (!this._lastPostTimeStamp) {
      return 1;
    }

    const differenceInSec = Math.round((now - this._lastPostTimeStamp) / 1000);

    return differenceInSec;
  }
}
